import { z } from "zod";

export type ApprovalGroupLevel = "lider" | "senior" | "medio" | "junior";

export interface ApprovalUser {
  id: string;
  name: string;
  last_name: string;
  full_name: string;
  email: string;
  level?: ApprovalGroupLevel;
}

export interface SeniorityValues {
  [key: number]: {
    amount: number;
  };
}

export interface ApprovalGroupFormData {
  name: string;
  description?: string;
  type: string;
  seniorityValues?: SeniorityValues[];
}

export const ApprovalGroupSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(50),
  usersCount: z.number().min(0).optional(),
  description: z.string().min(0).max(200).optional(),
  type: z.string(),
  canDeactivate: z.boolean().optional(),
  status: z.string().optional(),
  created_at: z.iso.datetime().nullable(),
  deleted_at: z.iso.datetime().nullable(),
  updated_at: z.iso.datetime().nullable(),
  members_count: z.array(z.any()).optional(), // Members relationship
  members: z.array(
    z.object({
      id: z.string(),
      name: z.string().min(1).max(50),
      last_name: z.string().min(1).max(50).optional(),
      email: z.email().optional(),
      seniority: z.number().min(1).max(4).optional(), // 1 (lider) to 4 (junior)
    }),
  ),
  workloads: z
    .array(
      z.object({
        id: z.string(),
        seniority: z.number().min(1).max(4),
        amount: z.number().min(0),
      }),
    )
    .optional(),
});

export type ApprovalGroupType = z.infer<typeof ApprovalGroupSchema>;

export const newApprovalGroupSchema = z.object({
  name: z
    .string()
    .trim()
    .nonempty("El nombre del grupo es requerido")
    .min(1, "El nombre del grupo es requerido")
    .max(50, "Máximo 50 caracteres"),
  description: z.string().trim().max(200, "Máximo 200 caracteres").optional(),
  type: z.string().nonempty("El tipo del grupo es requerido"),
});

// TODO: check for compatibility between ApprovalGroupType and GroupType
export const GroupSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(50),
  members_count: z.number().min(0).optional(),
  description: z.string().min(0).max(200),
  created_at: z.iso.datetime().nullable(),
});

export type GroupType = z.infer<typeof GroupSchema>;
